import { PropsWithChildren, ReactElement } from 'react';

import { horizonTheme } from '@changegps/horizon-component-library';
import { CssBaseline, ThemeProvider } from '@mui/material';

const MuiThemeProvider = (props: PropsWithChildren): ReactElement => {
  return (
    <ThemeProvider theme={horizonTheme}>
      <CssBaseline />
      {props.children}
    </ThemeProvider>
  );
};

export default MuiThemeProvider;
